import { Controller } from "@hotwired/stimulus"
import { initializeDynamicSearchForms } from "../../vue_components";
export default class extends Controller {
  connect() {
    initializeDynamicSearchForms()
  }
}

